// Les animations des tutos (D-091) : boucles muettes filmées automatiquement sur le club de démo par
// scripts/guide/film.mjs, servies en public/guide/<tuto>.webp (et leur affiche <tuto>.jpg).
// Fichier ÉCRIT PAR film.mjs (durée en secondes de chaque boucle) : ne pas le modifier à la main.
export const FILMS: Record<string, number> = {
  'abonnement': 11,
  'agenda': 10,
  'annonces': 10,
  'avantages': 10,
  'badges-bureau': 25,
  'chef-groupe': 25,
  'code-perso': 10,
  'convoquer-match': 17,
  'creer-groupe': 11,
  'creer-play': 10,
  'demander-benevoles': 10,
  'demandes': 10,
  'diffuser': 10,
  'dossiers-licence': 15,
  'ecrire-support': 22,
  'encourager': 10,
  'faire-appel': 16,
  'groupe-benevoles': 25,
  'groupes-bureau': 25,
  'importer-licencies': 20,
  'incertaine': 11,
  'indispo-semaine': 22,
  'indisponibilite': 11,
  'indispos-equipe': 11,
  'inviter': 10,
  'inviter-equipe': 11,
  'membres-roles': 10,
  'mes-badges': 25,
  'notifications': 10,
  'page-publique': 16,
  'partenaire-appel': 10,
  'partenaire-visibilite': 15,
  'partenaires': 10,
  'plan-seance': 15,
  'prendre-creneau': 18,
  'prepa-coach': 10,
  'prepa-joueur': 10,
  'prevenir-absence': 10,
  'programmer': 10,
  'prospection': 25,
  'qui-connait': 22,
  'saison-equipes': 14,
  'score-ffbb': 20,
  'subventions': 25,
  'subventions-bilan': 11,
  'subventions-chiffres': 21,
  'suivre': 19,
  'voir-play': 10,
};
